import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useI18nContext } from "@hopper-b2b/i18n";
import type { CarCardType } from "./CarCard";
import { CarsAvailabilitySelectors } from "~core-cars/store";
import {
  getBaggageQty,
  getVehicleClassLabelFromVehicle,
  getVehicleTransmissionLabel,
} from "~core-cars/utilities";

export const useCarCard = (props: CarCardType) => {
  const { car } = props;

  const { t } = useI18nContext();

  const searchDayCount = useSelector(
    CarsAvailabilitySelectors.getSearchDayCount
  );

  return useMemo(() => {
    const vehicleClass = getVehicleClassLabelFromVehicle(t, car.vehicle);
    const shouldUseFallback = car.vehicle.name.includes(
      "Description Not Available"
    );

    return {
      context: {
        car,
        supplier: car.supplier,
        kind: vehicleClass,
        name: car.vehicle.name,
        useFallbackName: shouldUseFallback,
        image: car.vehicle.images?.["original"],
        attributes: {
          passengersQuantity: car.vehicle.passengerQty,
          unlimitedMileage: car.hasUnlimitedMileage,
          baggageQuantity: getBaggageQty(car.vehicle),

          transmissionType: getVehicleTransmissionLabel(
            t,
            car.vehicle.transmissionType
          ),
          airConditioning: car.vehicle.airConditioning,
        },
        cancellationPolicy: car.cancellationPolicy,
        prices: props.car.totalCharge,
        searchDayCount,
        pickup: car.pickUp,
      },
    };
  }, [car, t, props.car.totalCharge, searchDayCount]);
};
